<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title has-text-weight-medium">
                Forwarding Address
            </p>
            <button
                class="delete"
                aria-label="close"
                @click="$parent.close()"
            />
        </header>
        <section class="modal-card-body">
            <form @submit.prevent="submit">
                <p>
                    Please supply an alternative address to contact you after you move out.
                </p>

                <FormNotification />

                <SavingNotification>
                    Sending...
                </SavingNotification>

                <div class="columns">
                    <div class="column is-4">
                        <b-field label="Building Number">
                            <b-input
                                v-model="BuildingNumber"
                                v-validate="{ required: true }"
                                name="BuildingNumber"
                            />
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="Street">
                            <b-input
                                v-model="Street"
                                v-validate="{ required: true }"
                                name="Street"
                            />
                        </b-field>
                    </div>
                </div>

                <b-field label="Town">
                    <b-input
                        v-model="Town"
                        v-validate="{ required: true }"
                        name="Town"
                    />
                </b-field>

                <b-field label="County">
                    <b-input
                        v-model="County"
                        v-validate="{ required: true }"
                        name="County"
                    />
                </b-field>

                <div class="columns">
                    <div class="column">
                        <b-field label="Postcode">
                            <b-input
                                v-model="Postcode"
                                v-validate="{ required: true }"
                                name="Postcode"
                            />
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="Country">
                            <b-input
                                v-model="Country"
                                v-validate="{ required: true }"
                                name="Country"
                            />
                        </b-field>
                    </div>
                </div>

                <b-button
                    type="is-info"
                    tag="button"
                    :disabled="isSending || isSuccess"
                    native-type="submit"
                >
                    Submit
                </b-button>
            </form>
        </section>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Form from '../mixins/form.js';
import { mapState } from 'vuex';

export default {
    mixins: [
        Form,
    ],

    computed: {
        ...mapState('tenancyProperty', [
            'tenancy',
        ]),
        ...mapFields('forwardingAddress', [
            'BuildingNumber',
            'Street',
            'Town',
            'County',
            'Postcode',
            'Country',
        ]),
    },

    methods: {
        submit() {
            this.isSuccess = null;

            this.validate()
            .then((result) => {
                if (! result) {
                    return this.parseClientErrors();
                }

                this.isSending = true;

                this.$store.dispatch('forwardingAddress/submit', this.tenancy.TenancyPK)
                .then((response) => {
                    this.statusMessage = response.data.message;
                    this.statusType = 'success';
                    this.isSuccess = true;
                })
                .catch((error) => {
                    this.parseServerErrors(error);
                    this.isSuccess = false;
                })
                .then(() => {
                    this.isSending = false;
                });
            });
        },
    },
};
</script>
